const GENERIC_ERROR = 'Não foi possível enviar a mensagem. Tente novamente mais tarde.';

/**
 * Remove tags e decodifica entidades HTML de conteúdo que devia ser texto simples
 * (ex.: colado de um Word/editor rico para um campo de texto do backoffice).
 */
export function stripHtml(value) {
  if (typeof value !== 'string') {
    return value;
  }

  const withoutTags = value.replace(/<[^>]*>/g, ' ');
  const decoded = withoutTags.replace(/&[a-zA-Z0-9#]+;/g, (entity) => {
    const el = document.createElement('textarea');
    el.innerHTML = entity;
    return el.value;
  });

  return decoded.replace(/\s+/g, ' ').trim();
}

export function sanitizeApiMessage(message) {
  if (typeof message !== 'string') {
    return GENERIC_ERROR;
  }

  const cleaned = message
    .replace(/<[^>]*>/g, '')
    .replace(/javascript:/gi, '')
    .replace(/data:text\/html/gi, '')
    .trim();

  if (!cleaned) {
    return GENERIC_ERROR;
  }

  return cleaned.slice(0, 400);
}
